import { type ValoriSezione } from '@framework/api-client/api/inquiries-compile/schemas/valoriSezione.ts';
import { type IEngineValidationContext } from '@framework/common-web/engine/engine-validation/IEngineValidationContext.ts';
import { deserializeFormSectionsValues } from '@framework/engine/validator/serialize/deserializeFormSectionsValues.ts';
import { useMemo } from 'react';
import { type AnyObject, type ObjectSchema } from 'yup';

interface IUseDeserializedModuleValuesProps {
  schema: ObjectSchema<AnyObject> | null | undefined;
  values: ValoriSezione[];
  validationContext: IEngineValidationContext;
}

/**
 * Deserializes API section values to form values shape.
 *
 * Schema cast (with live semantic field re-evaluation) happens in FormHandler.castInitialValues,
 * not here. Only parses wire format to JS objects.
 *
 * Note: validationContext is NOT passed here; it's handled by FormHandler.
 */
export function useDeserializedModuleValues(
  props: IUseDeserializedModuleValuesProps,
) {
  const { schema, values } = props;

  return useMemo(() => {
    if (!schema) return {};
    return deserializeFormSectionsValues(schema, values) ?? {};
  }, [schema, values]);
}
